<template>
    <bubble-menu
        :tippy-options="{ duration: 100, maxWidth: 'none', hideOnClick: 'toggle' }"
        :editor="editor"
        :should-show="shouldShowBubble"
        v-if="editor"
    >
        <div class="flex flex-1 bg-gray-150 shadow rounded p-1 text-gray-700 -m-2">
            <composer-button
                :disabled="disabled"
                icon="regular/text-bold"
                color="light-gray"
                :tooltip-content="$t('composer.tools.bold')"
                :selected="events.isActive('bold')"
                @click="editor.chain().focus().toggleBold().run()"
            />
            <composer-button
                :disabled="disabled"
                icon="regular/text-italic"
                :tooltip-content="$t('composer.tools.italic')"
                color="light-gray"
                :selected="events.isActive('italic')"
                @click="editor.chain().focus().toggleItalic().run()"
            />
            <composer-button
                :disabled="disabled"
                icon="regular/text-underline"
                :tooltip-content="$t('composer.tools.underline')"
                color="light-gray"
                :selected="events.isActive('underline')"
                @click="editor.chain().focus().toggleUnderline().run()"
            />

            <composer-button
                :disabled="disabled"
                icon="regular/text-strike-through"
                :tooltip-content="$t('composer.tools.strikethrough')"
                color="light-gray"
                :selected="events.isActive('strike')"
                @click="editor.chain().focus().toggleStrike().run()"
            />

            <color-picker
                mode="swatch-only"
                classes="flex-1 border-none"
                button-color="light-gray"
                :selected-color="editor.getAttributes('textStyle').color"
                @input="events.setColorText"
            >
                <template #trigger>
                    <div class="relative">
                        <div
                            class="absolute z-20 inset-0 h-2 w-2 m-1 rounded-md pointer-events-none shadow"
                            :style="{ 'background-color': editor.getAttributes('textStyle').color }"
                        />
                        <composer-button
                            color="light-gray"
                            :tooltip-content="$t('composer.tools.textColor')"
                            icon="regular/color-brush-3"
                        />
                    </div>
                </template>
            </color-picker>

            <composer-button
                :disabled="disabled"
                icon="regular/eraser"
                color="light-gray"
                :tooltip-content="$t('composer.tools.erase')"
                @click="editor.chain().focus().unsetAllMarks().run()"
            />
            <composer-button
                :disabled="disabled"
                icon="regular/hyperlink"
                :tooltip-content="$t('composer.tools.link')"
                color="light-gray"
                @click="events.openLink"
            />
            <div class="relative">
                <composer-button
                    :icon="alignIcon"
                    dropdown
                    :dropdown-opened="alignDropDownOpened"
                    color="light-gray"
                    :tooltip-content="$t('composer.tools.align')"
                    @click="alignDropDownOpened = !alignDropDownOpened"
                />
                <div
                    class="absolute top-0 -mt-12 -ml-14 bg-gray-100 rounded flex shadow"
                    v-click-away="onHide"
                    v-if="alignDropDownOpened"
                >
                    <composer-button
                        :disabled="disabled"
                        icon="regular/paragraph-left-align"
                        :tooltip-content="$t('composer.tools.alignLeft')"
                        tooltip-placement="top"
                        color="light-gray"
                        :selected="events.isActive({ textAlign: 'left' })"
                        @click="events.onClickAlign('left')"
                    />
                    <composer-button
                        :disabled="disabled"
                        icon="regular/paragraph-center-align"
                        :tooltip-content="$t('composer.tools.alignCenter')"
                        tooltip-placement="top"
                        color="light-gray"
                        :selected="events.isActive({ textAlign: 'center' })"
                        @click="events.onClickAlign('center')"
                    />
                    <composer-button
                        :disabled="disabled"
                        icon="regular/paragraph-right-align"
                        :tooltip-content="$t('composer.tools.alignRight')"
                        tooltip-placement="top"
                        color="light-gray"
                        :selected="events.isActive({ textAlign: 'right' })"
                        @click="events.onClickAlign('right')"
                    />
                    <composer-button
                        :disabled="disabled"
                        icon="regular/paragraph-justified-align"
                        :tooltip-content="$t('composer.tools.justify')"
                        tooltip-placement="top"
                        color="light-gray"
                        :selected="events.isActive({ textAlign: 'justify' })"
                        @click="events.onClickAlign('justify')"
                    />
                </div>
            </div>
        </div>
    </bubble-menu>
</template>

<script>
    import ComposerButton from '@/components/composer/ComposerButton.vue';
    import ColorPicker from '@/components/lead/inputs/ColorPicker.vue';
    import { BubbleMenu } from '@tiptap/vue-3';

    export default {
        inject: ['events'],

        components: {
            ColorPicker,
            ComposerButton,
            BubbleMenu,
        },

        props: {
            editor: {
                type: Object,
            },
            alignIcon: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                alignDropDownOpened: false,
            };
        },

        methods: {
            shouldShowBubble() {
                return !(this.editor.view.state.selection.empty || this.editor.isActive('image'));
            },

            onHide() {
                this.alignDropDownOpened = false;
            },
        },
    };
</script>
